import { LabelQuestionConfig, LabelResponseState } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { routineMessageStyles } from '../../../components/routineMessageStyles';
import { RoutineQuestionMessage, RoutineQuestionMessageProps } from '../types';

export const LabelQuestionMessage: RoutineQuestionMessage<
  LabelQuestionConfig,
  LabelResponseState
> = (
  props: RoutineQuestionMessageProps<LabelQuestionConfig, LabelResponseState>
) => {
  const labels = (props.response.labels ?? []).map(
    (label: { id: string; name: string }) => label.name
  );
  const { t } = useTranslation();

  return (
    <View style={props.textStyle}>
      <Text style={routineMessageStyles.text}>
        {t('issue.common.labelsApplied')}:{' '}
        {labels.length > 0 ? labels.join(', ') : '-'}
      </Text>
    </View>
  );
};
